import { CALL_API } from 'redux-api-middleware'
import { get, post, put, destroy } from 'utils/network'

export const fetchPresets = () => (dispatch, getState) => {
  if (getState().preset.get('hasFetched')) {
    return Promise.resolve()
  }
  const request = get('/presets')
  request.types = ['PRE_REQ', 'PRE_GET_SUCC', 'NOTIF_FAIL']
  return dispatch({ [CALL_API]: request })
}

export const savePreset = (payload) => {
  let request = null
  if (payload.get('id')) {
    // update
    request = put('/presets/' + payload.get('id'), payload)
  } else {
    // create
    request = post('/presets', payload)
  }
  request.types = ['PRE_REQ', 'PRE_SAVE_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}

export const deletePreset = (id) => {
  const request = destroy(`/presets/${id}`)
  request.types = ['PRE_REQ', 'PRE_DEL_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}

export const savePresetFee = (presetID, payload) => {
  let request = null
  if (payload.get('id')) {
    // update
    request = put(`/presets/${presetID}/fees/${payload.get('id')}`, payload)
  } else {
    // create
    request = post(`/presets/${presetID}/fees`, payload)
  }
  request.types = ['PRE_REQ', 'PRE_PF_SAVE_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}

export const deletePresetFee = (presetID, pFeeID) => {
  const request = destroy(`/presets/${presetID}/fees/${pFeeID}`)
  request.types = ['PRE_REQ', 'PRE_PF_DEL_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}



// WEBPACK FOOTER //
// ./src/containers/FeesPresets/actions.js